/*
  Add custom scripts here
*/

const Swal = require('sweetalert2');
window.Swal = Swal;
import 'sweetalert2/dist/sweetalert2.min.css';

/**
 * To check if user has specific permission
 * @param {*} permissionName 
 * @returns 
 */
window.hasPermission = (permissionName) => {
    if (isAdmin === '1' || isAdmin === 1 || isAdmin === true) {
        return true;
    }
    return userPermissions[permissionName] === true;
};
